export const colors = {
  contentOnDarkSubtle: "#ffffffb3",
  themeExtensionComponentDailyJackpotDefaultBackground: "rgba(28,29,29,0.85)",
  themeExtensionComponentDailyJackpotDefaultContent: "#ffffff",
  themeExtensionComponentDailyJackpotUrgentContent: "#ffffff",
  themeExtensionComponentDailyJackpotUrgentBackground: "rgba(97,1,155,0.85)",
  themeExtensionComponentDailyJackpotUrgentPulseContent: "#ffffff",
  themeExtensionComponentDailyJackpotUrgentPulseBackground: "rgba(0,78,163,0.85)",
  themeExtensionComponentDailyJackpotJustWonContent: "#ffffff",
  themeExtensionComponentDailyJackpotJustWonBackground: "rgba(28,29,29,0.85)",
  themeExtensionComponentGameLabelNewContent: "#ffffff",
  themeExtensionComponentGameLabelNewBackground: "#D22839",
  themeExtensionComponentGameLabelNewBorder: "#EA6875",
  themeExtensionComponentGameLabelExclusiveContent: "#ffffff",
  themeExtensionComponentGameLabelExclusiveBackground: "#7401B7",
  themeExtensionComponentGameLabelExclusiveBorder: "#A530F3",
  themeExtensionComponentGameLabelJackpotContent: "#ffffff",
  themeExtensionComponentGameLabelJackpotBackground: "#0070EB",
  themeExtensionComponentGameLabelJackpotBorder: "#64AEFF",
};